// extracted by mini-css-extract-plugin
export default {"modal-bdy":"modal-bdy","review-redirect":"review-redirect","heading-txt":"heading-txt","content":"content"};